var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-color-picker',{staticClass:"control-element",attrs:{"itemid":"left-color","dot-size":"25","swatches-max-height":"20","elevation":"2","hide-canvas":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }